import { RefObject, useImperativeHandle, useState } from 'react';
import { OptionType, SelectMenuHandle } from '../SelectMenu/types';

/**
 * Hook that attaches the `scrollToGroup` and `scrollToOption` imperative
 * handlers to the options component ref. It also contains the state for
 * which option or group was scrolled to; these are used to match the option
 * or group header element in the options component. Returns ref getters that
 * take in an option and returns a ref that will scroll to the matched group
 * or option, respectively.
 * @param ref ref for the options component
 * @returns the scrollTo ref getters for the option and group
 */
export const useScrollToHandle = (ref?: RefObject<SelectMenuHandle>) => {
  // the imperative handle functions set the group or option key to scroll to
  const [scrollToGroup, setScrollToGroup] = useState<string>();
  const [scrollToOption, setScrollToOption] = useState<string>();
  useImperativeHandle(ref, () => ({
    scrollToGroup: (group: string) => setScrollToGroup(group),
    scrollToOption: (key: string) => setScrollToOption(key),
  }));
  return {
    groupRef: (option: OptionType<any>) => {
      if (option.group !== scrollToGroup) return;
      return (el: HTMLLIElement | null) => {
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth' });
        setScrollToGroup(undefined);
      };
    },
    optionRef: (option: OptionType<any>) => {
      if (option.key !== scrollToOption) return;
      return (el: HTMLLIElement | null) => {
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth' });
        setScrollToOption(undefined);
      };
    },
  };
};
